import React from 'react'
import { IonCol, IonList, IonRow } from '@ionic/react'
import NumberPad from '../../../components/numberPad/NumberPad.component'
import SingleSelect from '../../../components/singleSelect/SingleSelect.component'
import TextArea from '../../../components/textArea/TextArea.component'
import { CcHpiConstants } from '../store/ccHpi.constants'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getSituationSelector } from '../selectors'
import { setScDuration, setScDurationUnit, setSecondaryComplaint } from '../store/ccHpi.actions'
import { IOption } from '../../../common/common.types'
import { getCcHpiOptionsSelector } from '../../options/selectors'
import { ICcHpiOptionsState } from '../../options/store/options.types'
import { ISituationState } from '../store/ccHpi.types'
import { getDatapointsConfigSelector } from '../../configurations/selectors'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { IDataPointsConfig, IServiceConfig } from '../../configurations/store/configurations.types'
import Validation from '../../../components/validation/Validation.component'

const SecondaryComplaintContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { secondaryComplaint, scDuration, scDurationUnit }: ISituationState = useSelector(getSituationSelector)
  const { scDurationUnitsOptions }: ICcHpiOptionsState = useSelector(getCcHpiOptionsSelector)
  const { DP_COMPDURATION }: IDataPointsConfig = useSelector(getDatapointsConfigSelector)
  const { PR_COMPDURATION }: IServiceConfig = useSelector(getServiceConfigSelector)

  const secondaryComplaintOnChange = (e: CustomEvent) => {
    dispatch(setSecondaryComplaint(e.detail.value))
  }

  const setDurationOnChange = (numbers: string[]) => {
    dispatch(setScDuration(numbers.join('')))
  }

  const setDurationUnitOnChange = (option: IOption) => {
    dispatch(setScDurationUnit(option))
  }
  return (
    <>
      <IonList>
        <IonRow>
          <IonCol className='picklist'>
            <TextArea
              dataTestID='SecondaryComplaint'
              rows={3}
              cols={20}
              maxlength={255}
              value={secondaryComplaint}
              validationId={CcHpiConstants.SET_SECONDARY_COMPLAINT}
              onChangeAction={(e) => {
                secondaryComplaintOnChange(e)
              }}
            />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />

        {(DP_COMPDURATION === 1 ||
          (DP_COMPDURATION === 2 && PR_COMPDURATION === 1) ||
          scDuration ||
          scDurationUnit) && (
          <IonRow>
            <IonCol className='picklist'>
              <NumberPad
                elementId='SCDuration'
                dataTestId='SCDuration'
                values={scDuration ? scDuration.split('') : []}
                label={t('ccHpi.duration')}
                onNumPadClick={setDurationOnChange}
              />
              <Validation id={CcHpiConstants.SET_SCDURATION} />
            </IonCol>
            <IonCol>
              <SingleSelect
                dataTestID='SCDurationUnit'
                options={scDurationUnitsOptions}
                selectedOption={scDurationUnit}
                listHeader={t('ccHpi.durationUnit')}
                label={t('ccHpi.durationUnit')}
                action={setDurationUnitOnChange}
              />
            </IonCol>
          </IonRow>
        )}
      </IonList>
    </>
  )
}

export default SecondaryComplaintContent
